import React, { Component } from 'react'
import styled from 'styled-components'
import Text from '../components/Text'

const Box = styled.div`
  width: 100%;
`

const Title = styled.div`
  font-weight: 500;
  text-align: center;
  padding: 0 0 1rem 0;
`

const SwitcherBox = styled.div`
  border: 1px solid var(--${props => props.color});
  display: flex;
  border-radius: 1rem;
  overflow-x: auto;
`

const Button = styled.button`
  background: ${props => props.isActive ? `var(--${props.color})` : 'transparent'};
  color: ${props => props.isActive ? '#fff' : `var(--${props.color})`};
  flex: 1;
  line-height: 1rem;
  text-align: center;
  font-weight: 300;
  padding: 0.5rem;
  cursor: pointer;
  transition: all 0.2s;
`

const options = {
  language: [
    'ENGLISH',
    'SPANISH',
    'TAMIL',
  ],
  vfpScene: [
    'DRIVING',
    'KITCHEN',
    'RELAXING',
  ],
  storyScene: [
    'VALUES',
    'MEDICATIONS',
    'HABITS',
    'COMFORT',
  ],
  phoneSession: [
    'ONE',
    'TWO',
    'THREE',
  ],
}

export default class Switcher extends Component {
  render() {
    const { color, title, choices, value, onChange } = this.props

    return (
      <Box>
        {title &&
          <Title>
            <Text str={title} />
          </Title>
        }
        <SwitcherBox color={color}>
          {options[choices].map((choice, index) => (
              <Button
                key={index}
                isActive={choice === value}
                color={color}
                onClick={() => onChange(choice)}
              >
                <Text str={`choices.${choices}.${choice}`} />
              </Button>
          ))}
        </SwitcherBox>
      </Box>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Switcher.js